export default __webpack_public_path__ + "static/media/insure-me.bd05f43c.svg";